import {TYPE_PDF} from '@/contants/base';

export const getList = (state) => state.list
export const getHighlightVariant = (state) => state.highlightVariant
export const isPdfFile = state => {
  return state.file ? state.file.config.type === TYPE_PDF : false;
}
export const getCampaignEmailTemplate = (state) => state.campaignEmailTemplate;
export const getListAppUser = (state) => state.listAppUser;
export const getAllApplication = (state) => state.allApplication;
